export const getContrastColor = (hexColor) => {
  // Remove the hash if present
  let hex = hexColor.replace('#', '');

  // Convert 3-digit hex to 6-digit hex (e.g. #03F -> #0033FF)
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  // Convert hex to RGB decimal values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate relative luminance using the W3C standard
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // Return black for bright colors, white for dark colors
  return luminance > 0.5 ? '#000000' : '#ffffff';
};

const sharedCtx = document.createElement('canvas').getContext('2d');
sharedCtx.canvas.width = 1;
sharedCtx.canvas.height = 1;

export const colorToHex = (color) => {
  // Clear the previous value
  sharedCtx.fillStyle = '#000000';
  sharedCtx.fillStyle = color;

  return sharedCtx.fillStyle;
};
